import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

interface Props {
  rows?: number;
}

export const InfoBarsLoader: React.FC<Props> = ({ rows = 4 }) => {
  return (
    <Container>
      {Array.from({ length: rows }, (_, i) => i).map((idx) => (
        <Item key={`info-bars-loader-${idx}`}>
          <Skeleton height={20} />
          <Skeleton height={20} />
        </Item>
      ))}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  text-align: center;
`;

const Item = styled.div`
  display: grid;
  grid-template-columns: 1fr 40px;
  gap: 20px;
  margin-top: 25px;
`;
